import * as A from '@core/arena'

import * as ObjectUtils from '@core/objectUtils'

const keys = {
  steps: 'steps',
  id: ObjectUtils.keys.id,
  name: 'name',
}

export const stepNames = {
  entry: 'entry',
  cleansing: 'cleansing',
  analysis: 'analysis',
}

export const entryCode = '1'
export const cleansingCode = '2'
export const analysisCode = '3'

export const stepCodes = {
  [stepNames.entry]: entryCode,
  [stepNames.cleansing]: cleansingCode,
  [stepNames.analysis]: analysisCode,
}

export const steps = Object.keys(stepNames).map((name) => ({ id: stepCodes[name], name }))

export const getStepId = A.prop(keys.id)

export const getDefaultStep = () => A.pipe(A.head, getStepId)(steps)

export const getStep = (stepId) => A.find(A.propEq(keys.id, stepId), steps)

export const getStepIdByName = (stepName) => {
  const step = A.find(A.propEq(keys.name, stepName), steps)
  return getStepId(step)
}

const getStepIndex = (stepId) => A.findIndex(A.propEq(keys.id, stepId))

const getStepIncrement = (stepId, increment) =>
  A.pipe(
    getStepIndex(stepId),
    (idx) => A.add(idx, increment),
    (idx) => (idx >= 0 ? A.nth(idx, steps) : null)
  )(steps)

export const getNextStep = (stepId) => getStepIncrement(stepId, +1)

export const getPreviousStep = (stepId) => getStepIncrement(stepId, -1)

export const { getId } = ObjectUtils
export const getName = A.prop(keys.name)

export const areAdjacent = (step1, step2) => {
  if (!(step1 || step2)) {
    return false
  }

  const idx1 = getStepIndex(getId(step1))(steps)
  const idx2 = getStepIndex(getId(step2))(steps)
  return Math.abs(idx1 - idx2) === 1
}
